blockHeight('.card-block__image',1);
blockHeight('.card-block__title',1);

function blockHeight(block,wWidth){ 
	var $block = $(block),
			defaultWidth = 767,
			minWidth;

	if (wWidth) {
		minWidth = wWidth;
	}else{
		minWidth = defaultWidth;
	}

	function setHeight(){
		if ($(window).outerWidth() > minWidth) {
			var maxHeight = 0;

			$block.each(function(){
				if ($(this).height() > maxHeight) {
					maxHeight = $(this).height();
				}
			})

			$block.height(maxHeight);
		}else{
			$block.css('height', 'auto');
		}
	}
	setHeight();

	$(window).resize(function(){
		if ($(window).outerWidth() > minWidth) {
			var maxHeight = 0;

			$block.each(function(){
				$(this).css('height','auto');

				if ($(this).height() > maxHeight) {
					maxHeight = $(this).height();
				}
			})

			$block.height(maxHeight);
		}else{
			$block.css('height', 'auto');
		}
	})
}

function addText(elem, text){
	var $elem = $(elem),
			$elemText = $elem.text(),
			$text = text;

	var manipulationText = function(){
		if ($(window).outerWidth() < 513) {
			$elem.text($text);
		}else{
			$elem.text($elemText);
		}
	}
	manipulationText();

	$(window).resize(function(){
		manipulationText();
	})
}

addText('#popular-more', 'Посмотреть все');

function cardBorder(btn,block){
	var $btn = $(btn),
			$block = $(block);

	$btn.hover(
		function(){
			$(this).parent($block).addClass('active');
		},

		function(){
			$(this).parent($block).removeClass('active');
		}
	)
}
cardBorder('.card-block__btn--bg', '.card-block');